import React from 'react'

import Header from '@zet/common/components/header'
import { Accordian } from '@zet/design-system/accordian'
import { Stack } from '@zet/design-system/layout'
import { i18n } from '@zet/localization'
import { ScrollView } from 'react-native-gesture-handler'

export const FrequentlyAskedQuestions = () => {
  return (
    <Stack>
      <Header showBackIcon title={'Frequently Asked Questions'} />
      <ScrollView className="mb-5">
        {i18n.t('helpAndSupportFaqs').map((e, index) => (
          <Accordian
            title={e.question}
            content={e.answer}
            style={{
              width: '100%',
              marginTop: 0,
              marginBottom: 0,
            }}
            key={index}
          />
        ))}
        <Stack className="p-4"></Stack>
      </ScrollView>
    </Stack>
  )
}
